// extracted by mini-css-extract-plugin
export default {"widths":"styles_widths__ILpPP","packageBorder":"styles_packageBorder__jf8Du","orderItemPrice":"styles_orderItemPrice__WWiXJ"};